import request from '@/utils/request';

export const loginRequest = (row) => {
	return request({
		url: '/proFileApi/blade-auth/login',
		method: 'post',
		params: row,
		
	})
}

export const getCaptchaCode = (row) => {
	return request({
		url: '/proFileApi/blade-auth/get/code',
		method: 'get',
		params: row,
		
	})
}




export const phoneLogin = (row) => {
	return request({
		url: '/proFileApi/blade-auth/login/onTouch',
		method: 'post',
		params: row,
		
	})
}


export const refreshToken = (refreshToken) => request({
	url: '/proFileApi/blade-auth/token',
	method: 'post',
	params: {
	  refreshToken,
	  grantType: "refresh_token",
	  scope: "all",
	  
	}
  })

  
  export const registerRequest = (row) => {
	return request({
		url: '/proFileApi/blade-auth/register/phone',
		method: 'post',
		params: row,
		
	})
}


export const getCheckCode = (row) => {
	return request({
		url: '/proFileApi/blade-auth/check/phone',
		method: 'get',
		params: row
	})
}


export const updateUserInfo = (row) => {
	return request({
		url: '/proFileApi/customer/update',
		method: 'post',
		data: row,
		
	})
}